























// TODO: lineWidth=144を直に指定している
import { toFixed, formatPrice } from '@/utils/filters';

export default {
  name: 'FigureFunctionalSFC',
  props: {
    board: {
      required: true,
      type: Object,
    },
    lineMax: {
      required: true,
      type: Number,
    },
    rgb: {
      required: true,
      type: Array,
    },
  },
  filters: {
    toFixed,
    formatPrice,
  },
};
